import * as api from '../../api';
import { normalize } from 'normalizr';
import * as schema from '../schema';
import { getIsFetching } from './reducers.js';

export const fetchBookData = (dataURI, slug) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_BOOK_DATA_REQUEST',
    slug,
  });

  return api.fetchBookData(dataURI).then(
    response => {
      if (typeof response === 'object' && typeof response.pages === 'object') {
        dispatch({
          type: 'FETCH_BOOK_DATA_SUCCESS',
          slug,
          response,
        });
      } else {
        let errorObj = response.error
          ? response.error
          : { message: 'Unknown Error' };
        if (typeof Raven !== 'undefined')
          Raven.captureException(errorObj.message);
        dispatch({
          type: 'FETCH_BOOK_DATA_FAILURE',
          slug,
          error: errorObj,
          message: errorObj.message,
        });
      }
    },
    error => {
      if (typeof Raven !== 'undefined') Raven.captureException(error);
      let errorObj = error.error ? error.error : { message: 'Unknown Error' };
      dispatch({
        type: 'FETCH_BOOK_DATA_FAILURE',
        slug,
        error: errorObj,
        message: errorObj.message,
      });
    }
  );
};

export const fetchMedia = (id, qs = {}) => (dispatch, getState) => {
  if (getIsFetching(getState(), id)) {
    return Promise.resolve();
  }
  dispatch({
    type: 'FETCH_MEDIA_REQUEST',
    id,
  });

  return api.fetchMedia(id, qs).then(
    response => {
      if (response.length) {
        dispatch({
          type: 'FETCH_MEDIA_SUCCESS',
          id,
          response: normalize(response, schema.arrayOfMedia),
        });
      } else {
        let errorObj = response.error
          ? response.error
          : { message: 'Unknown Error' };

        if (errorObj.code !== 404) {
          if (typeof Raven !== 'undefined')
            Raven.captureException(errorObj.message);
        }
        dispatch({
          type: 'FETCH_MEDIA_FAILURE',
          id,
          error: errorObj,
          message: errorObj.message,
        });
      }
    },
    error => {
      if (typeof Raven !== 'undefined') Raven.captureException(error);
      let errorObj = error.error ? error.error : { message: 'Unknown Error' };
      dispatch({
        type: 'FETCH_MEDIA_FAILURE',
        id,
        error: errorObj,
        message: errorObj.message,
      });
    }
  );
};

export const onStartGame = slug => ({
  type: 'START_GAME',
  slug,
});

export const onEndGame = (slug, gameData) => (dispatch, getState) => {
  dispatch({
    type: 'END_GAME',
    slug,
    gameData,
  });

  setTimeout(() => {
    dispatch({
      type: 'SHOW_GAME_OVER_AD',
      slug,
      gameData,
    });
  }, 1000);
};

export const closeGameOverAd = slug => ({
  type: 'CLOSE_GAME_OVER_AD',
  slug,
});

export const onReplayGame = slug => ({
  type: 'REPLAY_GAME',
  slug,
});

export const onGameRestart = slug => ({
  type: 'GAME_RESTARTED',
  slug,
});

// const shouldFetchMedia = (state, urlSlug) => {
//   const media = state.media[urlSlug]
//   if (!media) {
//     return true
//   }
//   if (media.isFetching) {
//     return false
//   }
//   return media.didInvalidate
// }
//
// export const fetchMediaIfNeeded = mediaSlug => (dispatch, getState) => {
//   if (shouldFetchMedia(getState(), mediaSlug)) {
//     return dispatch(fetchMedia(mediaSlug))
//   }
// }
